import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Wallet = createSvgIcon(
  <path d="M15.473.006 3.485 6H0v18h21.75v-5.25H24v-7.5h-2.25V6H18.7L15.474.006ZM19.5 11.25h-3v7.5h3v3H2.25V8.25h1.742l.005.01.019-.01H19.5v3Zm2.25 5.25h-3v-3h3v3ZM16.145 6h-7.63l6.012-3.006L16.145 6Z" />,
  'Wallet'
);

export { Wallet };